import { useEffect, useState } from 'react';
import { NewSidesheetProps } from '../../types';
import { LuArrowLeft } from 'react-icons/lu';
import './SideSheetBase.scss';
import closeIcon from '../../assets/icons/closeIconTB.svg';

const SideSheet = ({
  onClose = () => {},
  children,
  active,
  closeable = true,
  title,
  subTitle,
  actions,
  canGoBack,
  goBack,
  outsideClick,
}: NewSidesheetProps) => {
  const overlayClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (e.target === e.currentTarget && closeable) {
      if (outsideClick && typeof outsideClick !== 'undefined') {
        if (outsideClick()) {
          onClose();
        }
        return;
      }

      onClose();
    }
  };

  const [showOverlay, setShowOverlay] = useState(false);
  const [showBody, setShowBody] = useState(false);

  useEffect(() => {
    if (active) {
      setShowOverlay(true);
    } else {
      setTimeout(() => {
        setShowOverlay(false);
      }, 500);
    }

    setTimeout(() => {
      setShowBody(active);
    }, 100);
  }, [active]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && active && closeable) {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [active, closeable, onClose]);

  return (
    <>
      {showOverlay && (
        <div className={`sidesheet-base ${showOverlay && 'active'} ${closeable && 'pointer'}`} onClick={overlayClick}>
          <div className={`sidesheet-base__container ${showBody && 'active'}`}>
            <div className="header">
              {canGoBack ? (
                <>
                  <button style={{ visibility: closeable ? 'visible' : 'hidden' }} className="back" onClick={goBack}>
                    <LuArrowLeft size={20} /> Go back
                  </button>
                </>
              ) : (
                <>
                  <button
                    style={{ visibility: closeable ? 'visible' : 'hidden' }}
                    className="close"
                    onClick={() => {
                      onClose();
                    }}
                  >
                    <img src={closeIcon} />
                  </button>
                </>
              )}

              <h3 className="title">{title}</h3>
              <span className="sub-title">{subTitle}</span>
            </div>
            <div className="body">{children}</div>
            {actions && <div className="actions">{actions}</div>}
          </div>
        </div>
      )}
    </>
  );
};

export default SideSheet;
